/**
 * Auth event bus for coordinating logout and auth state changes across stores.
 * Uses Symbols for event keys to guarantee uniqueness.
 */

import { createEventBus } from '@peanuds/composables';

// Define event symbols
export const AuthEventSymbols = {
  logout: Symbol('auth:logout'),
  login: Symbol('auth:login'),
  otpStateChanged: Symbol('auth:otpStateChanged'),
} as const;

/**
 * Singleton auth event bus
 * Use this in stores to subscribe to auth events
 */
export const authEventBus = createEventBus({
  logout: AuthEventSymbols.logout,
  login: AuthEventSymbols.login,
  otpStateChanged: AuthEventSymbols.otpStateChanged,
});
